import { useStyles } from './index.styles';

const BoxShadow = ({ children }) => {
  const classes = useStyles();
  return <div className={classes.root}>{children}</div>;
};

export default BoxShadow;
